import { render, staticRenderFns } from "./PromptModal.vue?vue&type=template&id=6dbbc89a&scoped=true&"
import script from "./PromptModal.vue?vue&type=script&lang=ts&"
export * from "./PromptModal.vue?vue&type=script&lang=ts&"
import style0 from "./PromptModal.vue?vue&type=style&index=0&id=6dbbc89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbbc89a",
  null
  
)

export default component.exports